import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import { clearDeploymentCacheIfNeeded } from './utils/deployment-cache';

if (environment.production) {
  enableProdMode();
}

// const bootstrap = async () => {
//   if (environment.production) {
//     const deploymentVersion = `${environment.appVersion}-${environment.version}`;
//     const isReloadingForFreshDeployment = await clearDeploymentCacheIfNeeded(deploymentVersion);

//     if (isReloadingForFreshDeployment) {
//       return;
//     }
//   }

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
